import { PaymentConfig } from './../components/generics/payment-form/payment-form.component';
import { UtilsService } from 'src/app/services/utils.service';
import { Warranty } from 'src/app/models/warranty.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Document } from '../models/document.model';
import { ID } from '../models/ID.model';
import { PaymentStatusInfo } from '../models/payments.model';

@Injectable({
    providedIn: 'root'
})
export class PaymentService {

    constructor(
        private http: HttpClient,
        private utilsService: UtilsService
    ) { }

    uploadPaymentProof(warrantyHash: string, file: File) {
        return this.utilsService.uploadFile<Document>(
            file,
            `/garantias/${ warrantyHash }/pagos/comprobantes/url`,
            `/garantias/${ warrantyHash }/pagos/comprobantes/confirmacion`,
        );
    }

    reportPayment(warrantyHash: string, pago: PaymentConfig) {
        return this.http.post<Warranty>(`/garantias/${ warrantyHash }/pagos`, pago);
    }

    verifyPayment(warrantyId: ID, paymentId: ID) {
        return this.http.post<Warranty>(`/garantias/${warrantyId}/pagos/${paymentId}/verificacion`, {});
    }

    getPaymentStatus(warrantyHash: string) {
        return this.http.get<PaymentStatusInfo>(`/garantias/${ warrantyHash }/pagos/estado`);
    }
}
